var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "OnHoldLock",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-on-hold-lock","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M53.3 59.4c-2.4 0-4.4-2-4.4-4.4V12.3c0-2.4 2-4.4 4.4-4.4 2.4 0 4.4 2 4.4 4.4V55c0 2.4-2 4.4-4.4 4.4z"/>
  <path d="M148.7 59.4c-2.4 0-4.4-2-4.4-4.4V12.3c0-2.4 2-4.4 4.4-4.4s4.4 2 4.4 4.4V55c0 2.4-1.9 4.4-4.4 4.4z"/>
  <path d="M53.3 84.1c-8.7 0-15.8-7.1-15.8-15.8s7.1-15.8 15.8-15.8 15.8 7.1 15.8 15.8S62 84.1 53.3 84.1zm0-22.7c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7c-.1-3.9-3.2-7-7-7z"/>
  <path d="M148.7 84.1c-8.7 0-15.8-7.1-15.8-15.8s7.1-15.8 15.8-15.8 15.8 7.1 15.8 15.8-7.1 15.8-15.8 15.8zm0-22.7c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7-3.1-7-7-7z"/>
  <path d="M249.6 170.8H240v-14.2c0-.5-.5-11.6-3.9-17.7-2.1-3.9-5.2-8.9-10.1-13.3-5.4-4.9-12.1-8.2-19.9-9.7-1.3-.3-4.4-.5-7.6-.5-2.7 0-4.8.2-6.6.5-7.6 1.6-21.4 6.5-29.3 22.3-3.8 7.7-4 18.1-4 20.1v12.6H146v68l101.7.1h2v-66.1l-.1-2.1zM167.2 158c0-2.7.4-10.8 3.1-16.2 6.3-12.6 17.4-16.6 23.4-17.8 1.2-.3 2.9-.4 4.9-.4 2.8 0 5.1.2 5.9.4 14 2.8 19.9 9.5 24.4 18.8 1.6 3.2 2.3 8.5 2.5 12.1 0 1 .1 5.8.1 5.8l.1 10.1-8.9.1-.1-14v-.2c-.9-9.4-4.7-16.2-11.6-21-3.8-2.5-8.9-3.1-10.3-3.1h-1.5c-9.5 0-16.6 4.3-20.6 12.4-1.7 3.4-2.6 5.7-3.1 8.1-.3 1.2-.5 4.4-.5 4.7v12.9h-7.7v-3c-.1-3.4-.1-7.4-.1-9.7zm16.4-3.6c.4-1.5 1.1-3.7 2.2-5.9 2.8-5.5 6.4-7.7 12.5-7.7h2c.3 0 3.5.1 6.1 1.9 3.1 2.3 6.9 6 7.8 14.5l.1 13.6H183v-11c.1-1.1.3-4.1.6-5.4zM154.3 179h87v51.5l-86.9.1-.1-51.6z"/>
  <path d="M19.8 43.3h164.4c5.7 0 10.3 4.6 10.3 10.3v65.9h8.8v-66c0-10.5-8.6-19.1-19.1-19.1H19.8C9.2 34.4.7 43 .7 53.5V190c0 10.5 8.6 19.1 19.1 19.1h132v-8.8h-132c-5.7 0-10.3-4.6-10.3-10.3V53.5c0-5.6 4.6-10.2 10.3-10.2z"/>
  <rect width="190.8" height="8.8" x="6.5" y="93.1"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/on-hold-lock.svg